// @ts-nocheck
export default defineNuxtPlugin(nuxtApp => {
  // Needed for hydration fix with varnish
  delete nuxtApp?.payload?.path
})
